var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1002_46",
    "data-name": "Component 1002 \\u2013 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13834",
    "data-name": "Rectangle 13834",
    width: 15.472,
    height: 15.472,
    fill: "#185edf",
    stroke: "#707070",
    strokeWidth: 1
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5504",
    "data-name": "Ellipse 5504",
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#e8eaee"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28603",
    "data-name": "Group 28603",
    transform: "translate(3.112 3.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_869",
    "data-name": "Mask Group 869",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13833",
    "data-name": "Rectangle 13833",
    width: 15.472,
    height: 15.472,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "file_copy_24dp_FILL0_wght400_GRAD0_opsz24",
    d: "M91.115-908.231H83.923a1.259,1.259,0,0,1-.924-.384,1.259,1.259,0,0,1-.384-.924v-9.154a1.259,1.259,0,0,1,.384-.924,1.259,1.259,0,0,1,.924-.384H88.5l3.923,3.923v6.538a1.259,1.259,0,0,1-.384.924A1.259,1.259,0,0,1,91.115-908.231Zm-3.269-7.192v-3.269H83.923v9.154h7.192v-5.884Zm-6.538,9.808a1.259,1.259,0,0,1-.924-.384,1.259,1.259,0,0,1-.384-.924v-9.154h1.308v9.154H88.5v1.308Zm2.615-13.077v0Z",
    transform: "translate(-78.475 920.544)",
    fill: "#185edf"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/Duplicate-icon.f8bb9ee21477c0b2f2570c4d16283b51.svg";
export { ForwardRef as ReactComponent };